import { FormLabel, FormLabelProps, Tooltip, useColorMode } from '@chakra-ui/react'
import React from 'react'
import { formLabelStyle } from './StyledInputs'

export const FormLabelWithMode: React.FC<FormLabelProps & {tooltipLabel?: string}> = (props) => {
  const { colorMode } = useColorMode()
  return (
    <Tooltip colorScheme={colorMode === 'dark' ? 'gray' : 'gray'} label={props.tooltipLabel ?? ''} placement='auto'>
      <FormLabel
        style={formLabelStyle}
        color={
          colorMode === 'dark' ? '#e2e2e2' : 'rgba(0, 0, 0, 0.8)'
        }
        {...props}
      >
        {props.children}
      </FormLabel>
    </Tooltip>
  )
}
